import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import Logo from "@/components/site/Logo";

function formatError(detail) {
  if (!detail) return "Erro desconhecido.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black relative flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="absolute inset-0 carbon-fiber opacity-40" />
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#E31B23]/10 blur-[120px]" />
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#008CFF]/10 blur-[120px]" />

      <div className="relative w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <Logo size={72} wordmarkClass="text-xl mt-3" className="flex-col gap-2" />
        </div>

        <form onSubmit={submit} className="rounded-2xl border border-white/10 bg-[#0a0a0a] p-8 md:p-10 glass" data-testid="admin-login-form">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg bg-[#E31B23]/10 flex items-center justify-center">
              <Lock className="w-5 h-5 text-[#E31B23]" />
            </div>
            <div>
              <div className="font-display font-bold text-lg">Painel Administrativo</div>
              <div className="text-xs text-neutral-500">Acesso restrito</div>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block overline text-neutral-400 mb-2">E-mail</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#111] border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#008CFF] outline-none"
                data-testid="admin-email"
                required
              />
            </div>
            <div>
              <label className="block overline text-neutral-400 mb-2">Senha</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#111] border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#008CFF] outline-none"
                data-testid="admin-password"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#E31B23] py-3 text-sm uppercase tracking-widest font-semibold glow-red disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
